<template>
  <div :class="`flex items-${align} flex-${type} ${type == 'col' ? 'gap-2' : ''}`">
    <h3 class="text-xs text-gray-500" v-if="title != ''"
      :class="{ 'ml-2': $i18n.locale == 'fa', 'mr-2': $i18n.locale != 'fa' }">
      {{ title }}:
    </h3>
    <p class="text-gray-700 text-sm">
      <slot></slot>
    </p>
  </div>
</template>
<script>
export default {
  // props: ["title", "type"],
  props: {
    title: {
      required: false,
      type: String,
      default: "",
    },
    type: {
      required: false,
      type: String,
      default: "row",
    },
    align: {
      required: false,
      type: String,
      default: "center",
    },
  },
};
</script>
